// import { useLocation, useNavigate } from 'react-router-dom';
// import p_nav_previous from '../../Assets/Images/p_nav_previous.svg';
// import p_map_location_arrow from '../../Assets/Images/p_map_location_arrow.svg';
// import p_search_location_arrow_secondary from '../../Assets/Images/p_search_location_arrow_secondary.svg';
// import p_address_home from '../../Assets/Images/p_address_home.svg';
// import p_address_others from '../../Assets/Images/p_address_others.svg';
// import p_address_work from '../../Assets/Images/p_address_work.svg';
// import p_address_delete from '../../Assets/Images/p_address_delete.svg';
// import p_address_time from '../../Assets/Images/p_address_time.svg';
// import { useEffect, useState } from 'react';
// import { addRecentLocation, clearRecentLocations, getMyLocations, removeMySavedLocation } from '../../Services/api';
// import { IoMdAdd } from "react-icons/io";
// const FindLocation = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { fromPage } = location.state || {};
//   const [savedLocations, setSavedLocations] = useState([]);
//   const [recentLocations, setRecentLocations] = useState([]);
//   const [searchResults, setSearchResults] = useState([]);
//   const [deleteid, setDeleteid] = useState()
//   const [isOpen, setIsOpen] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false)

//   const service = new window.google.maps.places.AutocompleteService();
//   const geocoder = new window.google.maps.Geocoder();

//   useEffect(() => {
//     getLocations();
//   }, []);
//   console.log('---', fromPage, '---', location);

//   // { state: { fromPage: "SelectAddres" } }
//   function getLocations() {
//     getMyLocations().then((res) => {
//       setSavedLocations(res.data?.saved_locations);
//       setRecentLocations(res.data?.recent_locations);
//     });
//   }

//   const displaySuggestions = function (predictions, status) {

//     if (predictions) {
//       setSearchResults(predictions)
//     }
//     if (
//       status != window.google.maps.places.PlacesServiceStatus.OK ||
//       !predictions
//     ) {
//       return;
//     }
//   }

//   function deleteSavedLocation() {
//     let param = {
//       "location_id": deleteid
//     }


//     removeMySavedLocation(param).then((res) => {

//       if (res.data?.status == '1') {
//         getLocations();
//         closeModal()
//       }
//     });
//   }


//   const handleChange = (event) => {
//     const { name, value } = event.target;

//     if (event.target.value != "") {
//       service.getQueryPredictions(
//         { input: event.target.value },
//         displaySuggestions
//       );
//     } else {
//       setSearchResults([]);
//     }
//   };

//   const handlePlaceSelect = async (place) => {
//     if (!place.place_id) {
//       return;
//     }

//     geocoder
//       .geocode({ placeId: place.place_id })
//       .then(({ results }) => {
//         if (!results || results.length === 0) return;

//         let geometry = results[0].geometry;
//         let formattedAddress = results[0].formatted_address; // ✅ Full formatted address
//         let localityName = results[0].address_components.find((comp) => comp.types.includes("locality"))?.long_name || "";


//         const updatedFormData = {
//           id: location?.state?.formData?.id,
//           location_id: location?.state?.formData?.location_id,
//           location_type: location?.state?.formData?.location_type,
//           location_type_id: location?.state?.formData?.location_type_id,
//           area: location?.state?.formData?.area,
//           direction: location?.state?.formData?.direction,
//           door_no: location?.state?.formData?.door_no,
//           user_id: location?.state?.formData?.user_id,
//           address: formattedAddress,
//           locality: localityName,
//           latlng: `${geometry.location.lat()},${geometry.location.lng()}`
//         };

//         navigate("/map-view", {
//           state: {
//             mapLat: geometry.location.lat(),
//             mapLng: geometry.location.lng(),
//             isFromFindLocation: true,
//             fromPage: fromPage,
//             formData: updatedFormData
//           },
//         });
//       });
//   };


//   const handleDeleteAddress = (idToDelete) => {
//     const updatedSavedLocations = savedLocations.filter(item => item.id !== idToDelete);
//     setSavedLocations(updatedSavedLocations);
//   };

//   function selectLocation(item, type) {
//     let param = {
//       "latlng": item.latlng,
//       "select_address": item.address,
//       "select_locality": item.locality
//     }

//     addRecentLocation(param).then((res => {
//       if (res.data?.status == '1') {
//         //  recent_locations_result

//         let locationdata = {
//           model: false,
//           location: type == 1 ? res?.data?.saved_locations_result[0] : res?.data?.recent_locations_result[0]
//         };
//         localStorage.setItem("getlocation", JSON.stringify(locationdata));
//         navigate(-1);
//       }
//     }))
//   }

//   function clearMyRecentLocation() {
//     clearRecentLocations().then((res) => {

//       if (res.data?.status == '1') {
//         setRecentLocations([]);
//       }
//     })
//   }



//   const openModal = (id) => {
//     setDeleteid(id)
//     setModalOpen(true);
//     setIsOpen(false)
//     setIsModalOpen(true)
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setIsModalOpen(false)
//   };
//   // location?.state?.formData?

//   const formData = {
//     address: location?.state?.formData?.address,
//     area: location?.state?.formData?.area,
//     direction: location?.state?.formData?.direction,
//     door_no: location?.state?.formData?.door_no,
//     id: location?.state?.formData?.id,
//     latlng: "",
//     locality: location?.state?.formData?.locality,
//     location_id: location?.state?.formData?.location_id,
//     location_type: location?.state?.formData?.location_type,
//     location_type_id: location?.state?.formData?.location_type_id,
//     user_id: location?.state?.formData?.user_id
//   };



//   return (
//     <>
//       <div className="findLocation p-3">
//         <div className="d-flex align-items-center ms-2 me-2">
//           <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(-1)} />
//           <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
//             Location
//           </div>
//         </div>

//         <div className="pt-3 pb-3 serachArea">
//           <input type="search" className="w-100 ff-poppins-semiBold fs-16" placeholder="Search an area or address " onChange={handleChange} />

//           <div className="d-flex align-items-center mt-3 pt-1 pb-1">
//             <img src={p_map_location_arrow} width={"16px"} height={"18px"} alt="Location Button" role="button" />
//             <div className="ff-poppins-semiBold fs-13 primary-text ms-2 pe-1" role="button"
//               onClick={() => navigate("/map-view", { state: { mapLat: null, mapLng: null, isFromFindLocation: true, fromPage: fromPage, formData: formData } })}  >
//               Use my current location
//             </div>
//           </div>
//         </div>

//         <div className='bodyContent scroller-style-y'>
//           {searchResults.length > 0 && (
//             <div className="searchResults">
//               <div className="ff-poppins-light fs-13 addressHeading">SEARCH RESULT</div>

//               <ul className="m-0 p-0">
//                 {searchResults?.map((item) => (
//                   <li className="mb-3" role='button' onClick={() => handlePlaceSelect(item)}>
//                     <div className="d-flex">
//                       <img src={p_search_location_arrow_secondary} width={"14px"} height={"14px"} alt="Location Button" role="button" />
//                       <div className="ff-poppins-semiBold fs-12 title ms-2 ps-1">
//                         {item?.structured_formatting.main_text}
//                       </div>
//                     </div>
//                     <div className="ff-poppins-light fs-11 ">
//                       {item?.description}
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}

//           {
//             fromPage != "profileaddAddress" && fromPage != 'userProfile' && fromPage != 'products' && fromPage != 'service' ?
//               savedLocations.length > 0 && searchResults.length === 0 && (
//                 <div className="savedAddress">
//                   <div className="ff-poppins-light fs-13 addressHeading">
//                     SAVED ADDRESSES
//                   </div>

//                   <ul className="m-0 p-0">
//                     {
//                       savedLocations.map((item, index) => (
//                         <li key={index} role='button'>
//                           <div className="d-flex justify-content-between align-items-center py-2">
//                             <div className="d-flex align-items-center" onClick={() => selectLocation(item, 1)}>
//                               {
//                                 item.location_type_id == '1' &&
//                                 <img src={p_address_home} width={"18px"} height={"18px"} alt="Address type" role="button" />
//                               }
//                               {
//                                 item.location_type_id == '2' &&
//                                 <img src={p_address_work} width={"18px"} height={"18px"} alt="Address type" role="button" />
//                               }

//                               {
//                                 item.location_type_id == '3' &&
//                                 <img src={p_address_others} width={"18px"} height={"18px"} alt="Address type" role="button" />
//                               }
//                               <div className="ff-poppins-semiBold fs-12 ms-2 ps-1">
//                                 {item.location_type}
//                               </div>
//                             </div>
//                             <div className="d-flex align-items-center">
//                               <img src={p_address_delete} width={"18px"} height={"18px"} alt="Delete address" role="button" onClick={() => openModal(item.id)} />
//                             </div>
//                           </div>
//                           <div className="ff-poppins-light fs-11" onClick={() => selectLocation(item, 1)}>{item.address}</div>
//                         </li>
//                       ))}
//                   </ul>

//                 </div>
//               ) : ""}

//           {
//             fromPage != "profileaddAddress" && fromPage != 'userProfile' && fromPage != 'products' && fromPage != 'service' ?
//               recentLocations.length > 0 && searchResults.length == 0 && (
//                 <div className="recentLocation">
//                   <div className="d-flex justify-content-between">
//                     <div className="ff-poppins-light fs-13 addressHeading">
//                       RECENT LOCATION
//                     </div>
//                     <div className="ff-poppins-light fs-13 addressHeading" role='button' onClick={clearMyRecentLocation}>CLEAR ALL</div>
//                   </div>

//                   <ul className="m-0 p-0">
//                     {recentLocations.map((item) => (
//                       <li className="mb-3" role='button' onClick={() => selectLocation(item, 2)}>
//                         <div className="d-flex">
//                           <img src={p_address_time} width={"16px"} height={"16px"} alt="Address type" role="button" />
//                           <div className="ff-poppins-semiBold fs-12 ms-2 ps-1">
//                             {item.locality}
//                           </div>
//                         </div>
//                         <div className="ff-poppins-light fs-11 ">{item.address}</div>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               )
//               : ""
//           }
//         </div>

//         {
//           modalOpen &&
//           <div class={`modal   d-flex align-items-center`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
//             <div class="modal-dialog modal-sm">
//               <div class="modal-content">
//                 <div class="modal-body ps-5 pe-5 pt-4 pb-4">
//                   <div className='text-center ff-poppins-regular fs-14'>Are you sure you want to delete this address ?</div>

//                   <div className='d-flex justify-content-between mt-3'>
//                     <button type="button" class="btn btn-secondary" onClick={() => closeModal()}>Cancel</button>
//                     <button type="button" class="btn btn-danger" onClick={() => deleteSavedLocation()} data-bs-dismiss="modal">Delete</button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         }

//       </div>
//       {isModalOpen && <div className="modal-backdrop fade show"></div>}

//     </>
//   );
// };
// //   }}
// export default FindLocation;
















import { useLocation, useNavigate } from 'react-router-dom';
import p_nav_previous from '../../Assets/Images/p_nav_previous.svg';
import p_map_location_arrow from '../../Assets/Images/p_map_location_arrow.png';
import p_search_location_arrow_secondary from '../../Assets/Images/p_search_location_arrow_secondary.svg';
import p_address_home from '../../Assets/Images/p_primary_address_home.png';
import p_address_others from '../../Assets/Images/p_address_others.svg';
import p_address_work from '../../Assets/Images/p_primary_address_work.png';
import p_address_delete from '../../Assets/Images/p_address_delete.svg';
import p_address_time from '../../Assets/Images/p_address_time.svg';
import { useEffect, useState } from 'react';
import { addRecentLocation, clearRecentLocations, getMyLocations, removeMySavedLocation } from '../../Services/api';
import { IoMdAdd } from "react-icons/io";
import p_nav_search from "../../Assets/Images/icons/primary_navbar_search.png";
import p_nav_addaddress from "../../Assets/Images/p_map_location_add.png";
import { IoIosArrowDropupCircle } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";

import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { HiDotsVertical } from "react-icons/hi";
import current_lable from "../../Assets/Images/icons/current_lable.png";
import { RiDeleteBin6Line } from "react-icons/ri";
import PingleFooter from '../../Components/Footer/pingleFooter';

const FindLocation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { fromPage } = location.state || {};
  const [savedLocations, setSavedLocations] = useState([]);
  const [openIndices, setOpenIndices] = useState([1, 2, 3]);
  const [recentLocations, setRecentLocations] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [deleteid, setDeleteid] = useState()
  const [isOpen, setIsOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false)

  const service = new window.google.maps.places.AutocompleteService();
  const geocoder = new window.google.maps.Geocoder();

  useEffect(() => {
    getLocations();
  }, []);

  // { state: { fromPage: "SelectAddres" } }
  function getLocations() {
    getMyLocations().then((res) => {
      setSavedLocations(res.data?.saved_locations);
      setRecentLocations(res.data?.recent_locations);
    });
  }

  const displaySuggestions = function (predictions, status) {

    if (predictions) {
      console.log('predictions :', predictions);

      setSearchResults(predictions)
    }
    if (status != window.google.maps.places.PlacesServiceStatus.OK || !predictions) {
      return;
    }
  }

  function deleteSavedLocation() {
    let param = {
      "location_id": deleteid
    }


    removeMySavedLocation(param).then((res) => {

      if (res.data?.status == '1') {
        getLocations();
        closeModal()
      }
    });
  }


  const handleChange = (event) => {
    const { name, value } = event.target;

    if (event.target.value != "") {
      service.getQueryPredictions(
        { input: event.target.value },
        displaySuggestions
      );
    } else {
      setSearchResults([]);
    }
  };

  const handlePlaceSelect = async (place) => {
    if (!place.place_id) {
      return;
    }

    geocoder
      .geocode({ placeId: place.place_id })
      .then(({ results }) => {
        if (!results || results.length === 0) return;

        let geometry = results[0].geometry;
        let formattedAddress = results[0].formatted_address; 
        let localityName = results[0].address_components.find((comp) => comp.types.includes("locality"))?.long_name || "";


        const updatedFormData = {
          id: location?.state?.formData?.id,
          location_id: location?.state?.formData?.location_id,
          location_type: location?.state?.formData?.location_type,
          location_type_id: location?.state?.formData?.location_type_id,
          area: location?.state?.formData?.area,
          direction: location?.state?.formData?.direction,
          door_no: location?.state?.formData?.door_no,
          user_id: location?.state?.formData?.user_id,
          address: formattedAddress,
          locality: localityName,
          latlng: `${geometry.location.lat()},${geometry.location.lng()}`
        };

        navigate("/map-view", {
          state: {
            mapLat: geometry.location.lat(),
            mapLng: geometry.location.lng(),
            isFromFindLocation: true,
            fromPage: fromPage,
            formData: updatedFormData
          },
        });
      });
  };


  const handleDeleteAddress = (idToDelete) => {
    const updatedSavedLocations = savedLocations.filter(item => item.id !== idToDelete);
    setSavedLocations(updatedSavedLocations);
  };

  const selectLocation = (item, type) => {
    let param = {
      "latlng": item.latlng,
      "select_address": item.address,
      "select_locality": item.locality
    }
    console.log('user search latlng : ', item);

    addRecentLocation(param).then((res) => {
      if (res.data?.status == '1') {
        let locationdata = {
          model: false,
          location: (type == 1 ? res.data?.saved_locations_result?.[0] : res.data?.recent_locations_result?.[0]) || {
            location_coordinates: item.latlng || item.location_coordinates,
            address: item.address,
            locality: item.locality || item.location_type || ""
          }
        };
        localStorage.setItem("getlocation", JSON.stringify(locationdata));
        navigate(-1);
      }
    }).catch((err) => {
      console.error("Error selecting location:", err);
    });
  }

  function clearMyRecentLocation() {
    clearRecentLocations().then((res) => {

      if (res.data?.status == '1') {
        setRecentLocations([]);
      }
    })
  }



  const openModal = (id) => {
    setDeleteid(id)
    setModalOpen(true);
    setIsOpen(false)
    setIsModalOpen(true)
  };

  const closeModal = () => {
    setModalOpen(false);
    setIsModalOpen(false)
  };
  // location?.state?.formData?

  const formData = {
    address: location?.state?.formData?.address,
    area: location?.state?.formData?.area,
    direction: location?.state?.formData?.direction,
    door_no: location?.state?.formData?.door_no,
    id: location?.state?.formData?.id,
    latlng: "",
    locality: location?.state?.formData?.locality,
    location_id: location?.state?.formData?.location_id,
    location_type: location?.state?.formData?.location_type,
    location_type_id: location?.state?.formData?.location_type_id,
    user_id: location?.state?.formData?.user_id
  };


  const toggleAccordion = (index) => {
    if (openIndices.includes(index)) {
      setOpenIndices(openIndices.filter((i) => i != index));
    } else {
      setOpenIndices([...openIndices, index]);
    }
  };

  return (
    <>
      <div className="findLocation p-3">
        <div className="d-flex align-items-center ms-2 me-2">
          <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(-1)} />
          <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
            Location
          </div>
        </div>

        <div className="pt-3 pb-3 serachArea">
          {/* <input type="search" className="w-100 ff-poppins-semiBold fs-16" placeholder="Search an area or address " onChange={handleChange} /> */}
          <div className="searchStores p-2">
            <input
              type='search'
              className="searchInput"
              placeholder="Search an area or address "
              onChange={handleChange}
            />

            <div className="searchMicIcon" >
              <img src={p_nav_search} width={"23px"} height={"23px"} />
            </div>
          </div>
          <div className='d-flex justify-content-between mt-3'>
            <div className="locationOption ">
              <div className="ff-poppins-semiBold fs-13 text-dark ms-2 pe-1" role="button"
                onClick={() => navigate("/map-view", { state: { mapLat: null, mapLng: null, isFromFindLocation: true, fromPage: fromPage, formData: formData } })}  >
                <span className=''>  Use my current</span><br />
                location
              </div>
              <img src={p_map_location_arrow} width={"22px"} height={"22px"} alt="Location Button" role="button" />
            </div>
            <div className="locationOption">
              <div className="ff-poppins-semiBold fs-13 ms-2 pe-1" role="button"
                onClick={() => navigate("/map-view", { state: { mapLat: null, mapLng: null, isFromFindLocation: true, fromPage: fromPage, formData: formData } })}  >
                <span className=''>Add new</span><br />
                address
              </div>
              <img src={p_nav_addaddress} width={"22px"} height={"22px"} alt="Location Button" role="button" />
            </div>
          </div>
          {/* <div className="d-flex align-items-center justify-content-around mt-3 pt-1 pb-1">
            <div className="ff-poppins-semiBold fs-13 primary-text ms-2 pe-1" role="button"
              onClick={() => navigate("/map-view", { state: { mapLat: null, mapLng: null, isFromFindLocation: true, fromPage: fromPage, formData: formData } })}  >
              Use my current location
            </div>
            <img src={p_map_location_arrow} width={"16px"} height={"18px"} alt="Location Button" role="button" />
          </div> */}
        </div>

        <div className='bodyContent '>
          <div style={{ marginBottom: "50px" }}>
            {searchResults.length > 0 && (
              <div className="savedAddress savedAddressContainer">
                <div className="section-header mt-2 mb-2" onClick={() => toggleAccordion(1)}>
                  <div className="ff-poppins-medium fs-13 addressHeading">
                    SEARCH RESULT
                  </div>
                  <div className="recentlySearchedStorebox__divider ms-1 me-1">
                    {" "}
                  </div>
                  <span className="arrow">
                    {openIndices?.includes(1) ? (
                      <IoIosArrowDropupCircle />
                    ) : (
                      <IoIosArrowDropdownCircle />
                    )}
                  </span>
                </div>
                {openIndices?.includes(1) && (
                  <div className='addressList '>
                    {searchResults.map((item, index) => (
                      <div className='addressListBox mt-2 ' onClick={() => handlePlaceSelect(item)}>
                        <div className=' d-flex justify-content-between'>

                          <div className='d-flex align-items-center h-100'>
                            <div className='locationTypeBox'>
                              <img src={p_search_location_arrow_secondary} width={"14px"} height={"15px"} className='' alt="Address type" role="button" />
                            </div>
                          </div>
                          <div className='ms-2'>
                            <span className='ff-poppins-medium fs-13'>  {item?.structured_formatting.main_text}</span>
                            <p >   {item?.description}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>)}
              </div>
            )}

            {
              fromPage != "profileaddAddress" && fromPage != 'userProfile' && fromPage != 'products' && fromPage != 'service' ?
                savedLocations.length > 0 && searchResults.length == 0 && (
                  <div className="savedAddress savedAddressContainer">
                    <div className="section-header mt-2 mb-2" onClick={() => toggleAccordion(2)}>
                      <div className="ff-poppins-medium fs-13 addressHeading">
                        SAVED ADDRESSES
                      </div>
                      <div className="recentlySearchedStorebox__divider ms-1 me-1">
                        {" "}
                      </div>
                      <span className="arrow">
                        {openIndices?.includes(2) ? (
                          <IoIosArrowDropupCircle />
                        ) : (
                          <IoIosArrowDropdownCircle />
                        )}
                      </span>
                    </div>
                    {openIndices?.includes(2) && (
                      <div className='addressList  '>
                        {savedLocations.map((item, index) => (
                          <div className='addressListBox mt-2 '>
                            <div className=' d-flex justify-content-between' onClick={() => selectLocation(item, 1)}>

                              <div className='d-flex align-items-center h-100'>
                                <div className='locationTypeBox'>
                                  <img src={item.location_type_id == '1' ? p_address_home : item.location_type_id == '2' ? p_address_work : p_address_others} width={"14px"} height={"15px"} className='' alt="Address type" role="button" />
                                </div>
                              </div>
                              <div className='ms-2'>

                                <span className='ff-poppins-medium fs-13'> {item?.location_type}</span>

                                {item?.status == 2 && <img src={current_lable} width={"55px"} height={"15px"} className='ms-2' alt="Current label" role="button" />}

                                <p>{item?.address}</p>
                              </div>
                            </div>
                            <div onClick={() => openModal(item, 1)}>
                              <RiDeleteBin6Line size={12} color='#989898' />
                            </div>
                          </div>
                        ))}
                      </div>)}
                  </div>
                ) : ""
            }

            {
              fromPage != "profileaddAddress" && fromPage != 'userProfile' && fromPage != 'products' && fromPage != 'service' ?
                recentLocations.length > 0 && searchResults.length == 0 && (

                  <div className="savedAddress savedAddressContainer mt-2">
                    <div className="section-header mt-2 mb-2" onClick={() => toggleAccordion(3)}>
                      <div className="ff-poppins-medium fs-13 addressHeading">
                        RECENT ADDRESSES
                      </div>
                      <div className="recentlySearchedStorebox__divider ms-1 me-1">
                        {" "}
                      </div>
                      <span className="arrow">
                        {openIndices?.includes(3) ? (
                          <IoIosArrowDropupCircle />
                        ) : (
                          <IoIosArrowDropdownCircle />
                        )}
                      </span>
                    </div>
                    {openIndices?.includes(3) && (
                      <div className='addressList '>
                        {recentLocations.map((item, index) => (
                          <div className='addressListBox mt-2 ' onClick={() => selectLocation(item, 2)}>
                            <div className=' d-flex justify-content-between'>
                              <div className='ms-2'>
                                <span className='ff-poppins-medium fs-13'> {item?.locality}</span>
                                <p >{item?.address}</p>
                              </div>
                            </div>
                            {/* <div>
                              <HiDotsVertical size={20} color='#989898' />
                            </div> */}
                          </div>
                        ))}
                      </div>)}
                  </div>
                )
                : ""
            }

          </div>
             <PingleFooter />
        </div>

        {
          modalOpen &&
          <div class={`modal d-flex align-items-center`} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-sm">
              <div class="modal-content">
                <div class="modal-body p-4">
                  <div className='text-center ff-poppins-regular fs-14'>Are you sure you want to delete this address ?</div>

                  <div className='d-flex justify-content-between mt-3'>
                    <button type="button" className="small-btn text-light primary-bg" onClick={() => closeModal()}>Cancel</button>
                    <button type="button" className="small-btn primary-text primary-bg-light  ms-3" onClick={() => deleteSavedLocation()} >Delete</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

      </div>
      {isModalOpen && <div className="modal-backdrop fade show"></div>}

    </>
  );
};
//   }}
export default FindLocation;
